import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { first } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Corso } from '../../../model/corso';
import { CourseService } from '../../../service/course.service';
import { CorsoModulo } from '../../../model/corsomodulo';
import { ModuloService } from 'src/app/service/modulo.service';

// const { Howl, Howler } = require('howler');

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.css']
})
export class CourseComponent implements OnInit {
    corso: Corso;
    corsoModulo: CorsoModulo;
    @ViewChild('downloadModuloLink') private downloadModuloLink: ElementRef;

    constructor(
        private route: ActivatedRoute,
        private courseSrv: CourseService,
        private moduloSrv: ModuloService
    ) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params =>  {
            this.loadCorso(+params.get('courseId'));
        });
    }

    changeModulo(modulo: CorsoModulo) {
        this.corsoModulo = modulo;
    }

    public async downloadModulo(modulo: CorsoModulo): Promise<void> {
        const blob = await this.moduloSrv.downloadResource(this.corso.id, modulo.id);
        if ('navigator' in window && 'msSaveOrOpenBlob' in navigator) {
            //@ts-ignore
            window.navigator.msSaveOrOpenBlob(blob, modulo.fileLezionePdf);
        } else {
            const url = window.URL.createObjectURL(blob);
            const link = this.downloadModuloLink.nativeElement;
            link.href = url;
            link.download = modulo.fileLezionePdf;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    }

    private loadCorso(courseId: number) {
        this.courseSrv.getCourse(courseId)
        .pipe(first())
            .subscribe(
                data => {
                    this.corso = data;
                },
                error => {
                    return;
                }
            );
    }

}
